import { useMemo } from "react";
import { useEnv } from "@/core/env";
import { createApiInstance } from "./createApiInstance";

/**
 * Hook for accessing public API endpoints that don't require authentication
 * This version doesn't include token refresh or auth-related middleware
 */
const usePublicApi = () => {
  const { apiUrl } = useEnv();

  return useMemo(
    () => createApiInstance(apiUrl, { attachAuthToken: false }),
    [apiUrl],
  );
};

export default usePublicApi;
